export default __webpack_public_path__ + "static/media/dashboard_money.bea7beab.svg";